import lib from "./js-lib/lib.js";

let Careers = {
    type: () => {
        let path = lib.path();

        if(!path.includes('careers')) {
            return;
        }

        const URLParams = new URLSearchParams(window.location.search);
        const type = URLParams.get('type');

        if(type === null) {
            lib.id('for-professionals').classList.add('open');
            return false;
        }

        lib.id(type).classList.add('open');
        lib.id(type).scrollIntoView({ behavior: 'smooth',  block: "center"});

        return true;
    },
    idtourl: () => {
        if(lib.id('for-professionals')) {
            lib.id('for-professionals').addEventListener('click', () => {
                if ('URLSearchParams' in window) {
                    var searchParams = new URLSearchParams(window.location.search)
                    searchParams.set("type", "for-professionals");
                    var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
                    history.pushState(null, '', newRelativePathQuery);
                }
            });

        }

        if(lib.id('for-students')) {
            lib.id('for-students').addEventListener('click', () => {
                var searchParams = new URLSearchParams(window.location.search)
                searchParams.set("type", "for-students");
                var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
                history.pushState(null, '', newRelativePathQuery);
            });
    
        }
    }
};

export { Careers as default };